// Shared by the Load Calculation view and its PDF
export const MODES = [
  { key: 'harbour',    label: 'Harbour' },
  { key: 'underWay',   label: 'Under way' },
  { key: 'fishing',    label: 'Fishing' },
  { key: 'offloading', label: 'Offloading' },
  { key: 'emergency',  label: 'Emergency' },
];

export const SOURCE_KINDS = [
  { key: 'generator',   label: 'Generator' },
  { key: 'shore',       label: 'Shore connection' },
  { key: 'transformer', label: 'Transformer' },
  { key: 'ups',         label: 'UPS' },
  { key: 'battery',     label: 'Battery' },
  { key: 'other',       label: 'Other' },
];

// Source types that are fed from a breaker (a load on the primary side)
export const FED_KINDS = ['transformer', 'ups', 'other'];

// kW with decimal comma; empty for "not set"
export const kw = (v, decimals = 1) =>
  v == null || Number.isNaN(v) ? '' : Number(v).toLocaleString('da-DK', { minimumFractionDigits: decimals, maximumFractionDigits: decimals });

export const pct = (v) => (v == null ? '' : `${kw(v, 1)} %`);

// Load above this share of the available power is flagged
export const pctLevel = (v) => (v == null ? '' : v > 100 ? 'over' : v > 85 ? 'high' : '');

// Available kW of a source: kW when given, otherwise kVA × cos φ
export const sourceAvailable = (s) => (s.kw > 0 ? s.kw : (s.kva || 0) * (s.cosPhi || 1));

// Networks without consumers, sources or transformer loads (e.g. spare boards) are left out of the balance
export const networkInUse = (n) => n.consumersInstalled > 0 || n.sources.length > 0 || n.supplies.length > 0;

export const consumerLabel = (r) => [r.tag, r.description].filter(Boolean).join(' ');
